<div class="homepage header_top asdfghj">
  <section class="banner">
    <div class="container">
      <div class="row aic">
        <div class="col-lg-6 col-md-12 col-sm-12">
          <h5>
            NCare IVF - Where <br />
            Hope Meet Science
          </h5>
          <h2 class="visually-hidden">{{ pageHeading }}</h2>
          <p>
            At NCare IVF Kannur, Kerala, we understand that the journey to
            <br />
            parenthood is deeply personal, often filled with hope,
            <br />challenges, and emotions.
          </p>
          <div class="login_signup">
            <button class="pink_bg" (click)="contactus()">
              Book An Appointment
            </button>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img
            src="assets/images/home/banner.webp"
            alt="Best IVF Center in Kannur, Kerala"
          />
        </div>
      </div>
    </div>
  </section>
  <section class="sec_c">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-12">
          <img src="../../../assets/images/home/mission.webp" alt="..." />
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 oru_mssion">
          <h4 class="title_header">Our Mission</h4>
          <p>
            At NCare IVF, our mission is to empower individuals and couples with
            world class fertility care. We are committed to offering
            personalized treatments that integrate integrity, innovation, and
            expertise. Every patient receives tailored solutions backed by
            scientific advancements and compassionate care, ensuring the best
            possible chance of success.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 mt-4">
          <h4 class="title_header">Our Vision</h4>
          <p>
            Our vision is to be a trusted leader in reproductive medicine,
            transforming lives by providing advanced, ethical, and compassionate
            fertility solutions. We aim to set new benchmarks in fertility care,
            ensuring accessibility and excellence for everyone on the path to
            parenthood.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12 mt-4">
          <img src="assets/images/home/vission.webp" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section class="why_choose_ncare_ivf_kannur">
    <div class="container">
      <h4 class="title_header tac">Why Choose NCare IVF Kannur, Kerala</h4>
      <p class="title_para">
        Experience expert IVF treatment in Kannur with personalized care,
        advanced <br />
        technology, and ethical fertility solutions.
      </p>
      <div class="row">
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Personalized Fertility Care</h5>
          <p>
            Every fertility journey is unique, and so is our treatment approach.
            We create customized treatment plans to maximize your chances of
            success.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Advanced IVF Laboratory</h5>
          <p>
            Equipped with modern reproductive technologies, our laboratory
            ensures accuracy, safety, and the highest standards in fertility
            care.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Expert Fertility Specialists</h5>
          <p>
            Our experienced doctors, embryologists, and counselors provide
            dedicated support, guiding you every step of the way toward
            parenthood.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>High Success Rates</h5>
          <p>
            With a strong history of successful treatments, we have helped
            countless couples achieve their dream of having a baby.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Ethical & Transparent Treatment</h5>
          <p>
            At NCare IVF, we prioritize honesty and integrity, offering clear,
            ethical fertility care with no hidden costs.
          </p>
        </div>
        <div class="col-lg-5 col-md-5 col-sm-12">
          <h5>Comprehensive Fertility Services</h5>
          <p>
            From natural conception support to advanced treatments like IVF,
            ICSI, and PGT, we provide complete fertility solutions under one
            roof.
          </p>
        </div>
      </div>
    </div>
  </section>
  <section class="fertility_treatments_at_ncare_ivf mt-5">
    <div class="container">
      <h4 class="title_header tac">Fertility Treatments at NCare IVF</h4>
      <p class="title_para">
        At NCare IVF Kannur, Kerala, we offer a range of cutting-edge fertility
        treatments designed to address every challenge on <br />your path to
        parenthood. Our treatments are backed by advanced technologies and
        expert care to ensure the <br />
        highest success rates.
      </p>
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="ftnivf">
            <img src="../../../assets/images/home/ftnicf_1.webp" alt="" />
            <h6>Ovulation Induction Treatment</h6>
            <p>
              Ovulation Induction is a vital treatment for women with irregular
              cycles or ovulatory disorders. Using hormonal medications, we
              stimulate
            </p>
            <button
              [routerLink]="['./ovulation-induction']"
              class="pink_outlint"
            >
              See More
            </button>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="ftnivf">
            <img src="../../../assets/images/home/ftnicf_2.webp" alt="" />
            <h6>Intrauterine Insemination (IUI)</h6>
            <p>
              IUI is a simple, non-invasive procedure where sperm is placed
              directly into the uterus at ovulation.
            </p>
            <button
              [routerLink]="['./intrauterine-insemination']"
              class="pink_outlint"
            >
              See More
            </button>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="ftnivf">
            <img src="../../../assets/images/home/ftnicf_3.webp" alt="" />
            <h6>In Vitro Fertilization (IVF) </h6>
            <p>
              IVF is a highly effective treatment where eggs are fertilized
              outside the body and the embryo is transferred into the uterus
            </p>
            <button
              [routerLink]="['./in_vitro_fertilization']"
              class="pink_outlint"
            >
              See More
            </button>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="ftnivf">
            <img src="../../assets/images/home/ftnicf_4.webp" alt="" />
            <h6>ICSI & PICSI Treatment</h6>
            <p>
              For male infertility issues like low sperm count, ICSI and PICSI
              are groundbreaking techniques. ICSI involves injecting a sperm
              directly
            </p>
            <button
              [routerLink]="['./intracytoplasmic-sperm-injection']"
              class="pink_outlint"
            >
              See More
            </button>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="ftnivf">
            <img src="../../../assets/images/home/ftnicf_5.webp" alt="" />
            <h6>Preimplantation Genetic Testing</h6>
            <p>
              PGT screens embryos for genetic abnormalities, ensuring that only
              the healthiest embryos are implanted
            </p>
            <button
              [routerLink]="['./preimplantation-genetic-testing']"
              class="pink_outlint"
            >
              See More
            </button>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="ftnivf">
            <img src="../../../assets/images/home/ftnicf_6.webp" alt="" />
            <h6>Recurrent Implantation Failure Treatment </h6>
            <p>
              Ovulation Induction is a vital treatment for women with irregular
              cycles or ovulatory disorders. Using hormonal medications, we
              stimulate
            </p>
            <button
              [routerLink]="['./recurrent-implantation-failure']"
              class="pink_outlint"
            >
              See More
            </button>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="ftnivf">
            <img src="../../../assets/images/home/ftnicf_7.webp" alt="" />
            <h6>Recurrent Pregnancy Loss (RPL) Treatment</h6>
            <p>
              RPL treatment addresses the heartbreaking issue of multiple
              miscarriages. We offer personalized care that includes genetic
              testing
            </p>
            <button
              [routerLink]="['./recurrent-pregnancy-loss']"
              class="pink_outlint"
            >
              See More
            </button>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="ftnivf">
            <img src="../../../assets/images/home/ftnicf_8.webp" alt="" />
            <h6>Witnessing System</h6>
            <p>
              At NCare IVF Kannur, Kerala, we ensure the highest level of safety
              and transparency with the RI Witnessing System. This advanced
              electronic system monitors and verifies every step of your IVF
              cycle — from egg retrieval to embryo transfer — using a unique
              barcode identification. It prevents any mix-ups in the lab,
              providing complete reassurance that your eggs, sperm, and embryos
              are handled with utmost accuracy and care.
            </p>
            <button [routerLink]="['./witnessing-system']" class="pink_outlint">
              See More
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="meet_our_expert_fertility_specialist mt-5">
    <h4 class="title_header tac">Meet Our Expert Fertility Specialists</h4>
    <p class="title_para">
      Our dedicated team at NCare IVF Kannur, Kerala is committed to making your
      journey to <br />
      parenthood as smooth and successful as possible.
    </p>
    <div class="container-fluid">
      <div class="meet_fertility">
        <!-- <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="testimonalSlider"
          (init)="slickInit($event)" (breakpoint)="breakpoint($event)" (afterChange)="afterChange($event)"
          (beforeChange)="beforeChange($event)">
          <div ngxSlickItem class="meet_our_content" *ngFor="let testimonial of testimoniallist">
            <p class="meet_para">{{testimonial.description}}</p>
            <div class="meet_content">
              <img   [src]="environment.apiUrl + testimonial.image" alt="">
              <div>
                <h6>{{testimonial.name}}</h6>
                <p>{{testimonial.position}}</p>
              </div>
            </div>
          </div>

        </ngx-slick-carousel> -->
      </div>
    </div>
  </section>
  <section class="pink_bg_content mt-5">
    <div class="container">
      <div class="pink_bg_content_child">
        <h5>Your Dream of Parenthood Starts Here!</h5>
        <p>
          Struggling to conceive? You’re not alone, and you don’t have to wait
          any longer. At NCare IVF Kannur, Kerala, we <br />
          turn hope into reality with advanced fertility treatments and expert
          care.
        </p>
        <p>
          Highest Success Rates | Ethical & Transparent Care | Personalized
          Treatment Plans
        </p>
        <button (click)="contactus()">Book a Consultation Today</button>
      </div>
    </div>
  </section>
  <section class="our_success_number mt-5">
    <div class="container">
      <h4 class="title_header tac">Our Success in Numbers</h4>
      <p class="title_para">
        At NCare IVF, our success is not just defined by numbers, but by the
        families we’ve helped create. These figures reflect the <br />
        trust, dedication, and expertise that guide every treatment we provide.
        Here's a snapshot of our achievements:
      </p>

      <div class="row">
        <div class="col-lg-5 col-md-12 col-sm-12">
          <div class="osn_card">
            <img src="../../../assets/images/home/osn_card_1.webp" alt="" />
            <div>
              <h6>More than&nbsp;<span>10,000 +</span>&nbsp;IVF Babies Born</h6>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-12 col-sm-12">
          <div class="osn_card">
            <img src="../../../assets/images/home/osn_card_2.webp" alt="" />
            <div>
              <h6>Persistently&nbsp;<span>over 50%</span> IVF Success rate</h6>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-12 col-sm-12">
          <div class="osn_card">
            <img src="../../../assets/images/home/osn_card_3.webp" alt="" />
            <div>
              <h6><span>17+</span> Years Of Experience</h6>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-12 col-sm-12">
          <div class="osn_card">
            <img src="../../../assets/images/home/osn_card_4.webp" alt="" />
            <div>
              <h6>More than&nbsp;<span>25,000 +</span>&nbsp;IVF cycles</h6>
            </div>
          </div>
        </div>
        <div class="col-lg-5 col-md-12 col-sm-12">
          <div class="osn_card">
            <img src="../../../assets/images/home/osn_card_5.webp" alt="" />
            <div>
              <h6><span>3</span> Centers Across Kerala</h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="fetal_medicine_high_risk_pregnancy_care mt-5">
    <div class="container">
      <h4 class="title_header tac">
        Fetal Medicine & High-Risk Pregnancy Care
      </h4>
      <p class="title_para">
        At NCare IVF Kannur, Kerala, we understand that a healthy pregnancy
        requires expert care, especially when dealing with high-risk
        pregnancies. Our fetal medicine specialists offer comprehensive
        monitoring and treatment to ensure both the mother's and baby's
        well-being throughout the pregnancy.
      </p>

      <div class="row aic">
        <div class="col-lg-3 col-md-3 col-sm-12">
          <img
            src="../../../assets/images/fetal_medicine/prenatal_screening_bg.webp"
            alt=""
          />
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12">
          <h6>1. Prenatal Screening</h6>
          <p>
            Includes tests like First Trimester Screening, Quadruple Test, NIPT,
            and Pre-eclampsia Screening—offering early insight into chromosomal,
            genetic, and pregnancy-related risks to guide timely, personalized
            care.
          </p>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12">
          <h6>2. Antenatal scans</h6>
          <p>
            Includes Early Pregnancy, NT, Targeted Anomaly, Genetic Sonogram,
            3D/4D, Fetal ECHO, Fetal Neurosonogram and Growth Scans— each
            tailored to your trimester and clinical needs to ensure early
            detection, clarity, and confidence throughout pregnancy
          </p>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <img src="../../../assets/images/home/fmhrpc_3.webp" alt="" />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <img src="../../../assets/images/home/fmhrpc_1.webp" alt="" />
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12">
          <h6>3. Antenatal Interventions</h6>
          <p>
            Antenatal interventions like Amniocentesis, CVS, and Cordocentesis
            help diagnose genetic conditions in the fetus.Procedures like
            Amnioreduction and Multifetal Reduction manage complex pregnancies
            for safer outcomes.
          </p>
        </div>
        <div class="col-lg-8 col-md-8 col-sm-12">
          <h6>4. Fetal Therapy</h6>
          <p>
            Includes advanced in-utero procedures like Intrauterine Transfusion,
            RFA, Bipolar Cord Coagulation, Laser Therapy, and Fetal Shunt
            Placement— performed to treat life-threatening fetal conditions and
            protect the health of both baby and mother during high-risk
            pregnancies.
          </p>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <img src="../../../assets/images/home/fmhrpc_2.webp" alt="" />
        </div>
      </div>
    </div>
  </section>
  <section class="real_stories_real_miracles mt-5">
    <div class="container">
      <h4 class="title_header tac">Real Stories, Real Miracles</h4>
      <p class="title_para">
        At NCare IVF Kannur, Kerala, we are happy to have helped many families
        achieve their dreams of becoming parents. <br />
        Here are a few stories that show the success we’ve had with our
        patients:
      </p>
      <div class="row">
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="rsrm">
            <img src="../../../assets/images/home/rsrm_1.webp" alt="" />
            <div class="rsrm_content">
              <h6>– Sreelakshmi & Vishnu</h6>
              <p>
                The service I felt was very good, the staff and doctors were
                friendly and provided very clear information.
              </p>
              <img
                src="../../../assets/images/home/star.webp"
                class="star"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="rsrm">
            <img src="../../../assets/images/home/rsrm_2.webp" alt="" />
            <div class="rsrm_content">
              <h6>– Kavya & Arjun</h6>
              <p>
                The service I felt was very good, the staff and doctors were
                friendly and provided very clear information.
              </p>
              <img
                src="../../../assets/images/home/star.webp"
                class="star"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-sm-12">
          <div class="rsrm">
            <img src="../../../assets/images/home/rsrm_3.webp" alt="" />
            <div class="rsrm_content">
              <h6>– Anjana & Devendra</h6>
              <p>
                The service I felt was very good, the staff and doctors were
                friendly and provided very clear information.
              </p>
              <img
                src="../../../assets/images/home/star.webp"
                class="star"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="advance_embryo_tech mt-3">
    <div class="container">
      <h4 class="title_header tac">
        Advanced Embryo Techniques, IVF & Cryopreservation
      </h4>
      <p class="title_para">
        At NCare IVF Kannur, Kerala, we use the latest technologies to improve
        the success of our IVF treatments and <br />
        ensure the safety of both the mother and the embryos.
      </p>
      <div class="aet_ct">
        <span>01</span>
        <h6>Blastocyst Culture & Transfer – Maximizing Embryo Quality</h6>
        <p>
          Blastocyst culture involves growing embryos for five days before
          transferring them to the uterus. This process allows us to select the
          healthiest embryos with the best chance of implantation, improving IVF
          success rates.
        </p>
      </div>
      <div class="aet_ct">
        <span>02</span>
        <h6>Laser-Assisted Hatching – Enhancing Implantation</h6>
        <p>
          Laser-assisted hatching is a technique used to assist the embryo in
          breaking free from its protective shell (zona pellucida) to help it
          implant in the uterine lining. This method is particularly useful for
          patients who have experienced previous IVF failures.
        </p>
      </div>
      <div class="aet_ct">
        <span>03</span>
        <h6>
          Preimplantation Genetic Testing (PGT) – Detecting Genetic Disorders
        </h6>
        <p>
          PGT involves screening embryos for genetic disorders such as Down
          Syndrome or other inherited conditions before implantation. This
          allows for the selection of the healthiest embryos, reducing the risk
          of genetic diseases and improving pregnancy outcomes.
        </p>
      </div>
      <div class="aet_ct">
        <span>04</span>
        <h6>
          Embryo Cryopreservation & Witnessing Technology – Safe Embryo Storage
        </h6>
        <p>
          Embryo cryopreservation involves freezing embryos for future use. This
          technology allows patients to preserve embryos for later transfers,
          minimizing the need for multiple egg retrievals. Witnessing technology
          ensures that embryos are correctly matched and tracked, offering an
          extra layer of safety during the freezing and thawing process.
        </p>
      </div>
    </div>
  </section>
  <section class="blogs_section mt-3" *ngIf="blogs.length > 0">
    <div class="container position-relative">
      <h4 class="title_header tac">Our Latest Blogs</h4>
      <button class="view_all_link d-none d-md-block" [routerLink]="['/page/blogs']">View All Blogs &rarr;</button>
      <p class="title_para mb-4 tac">
        Stay updated with the latest news and insights from our fertility experts.
      </p>
      <div class="row">
        <div *ngFor="let blog of blogs" class="col-lg-3 col-md-6 col-sm-12 mb-4">
          <div class="blog_card">
            <div class="blog_img_container" *ngIf="blog.image">
              <img [src]="apiUrl + '/' + blog.image" alt="Blog Image">
            </div>
            <div class="blog_content">
              <div class="blog_text_content">
                <div *ngIf="extractFirstHeading(blog.description)" [innerHTML]="extractFirstHeading(blog.description)"></div>
                <h5 *ngIf="!extractFirstHeading(blog.description)">{{blog.name}}</h5>
              </div>
              <button class="pink_outlint" [routerLink]="['/blog-detail', blog.slug]">
                Read More
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="tac mt-2 d-md-none">
        <button class="pink_bg" [routerLink]="['/page/blogs']">
          View All Blogs &rarr;
        </button>
      </div>
    </div>
  </section>
  <section class="faq mt-5">
    <h4 class="title_header tac">Frequently Asked Questions</h4>
    <div class="container">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              Who should consider fertility treatment?
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Couples who have been trying to conceive for over a year without
              success, women with irregular periods, those with a history of
              miscarriages, or individuals diagnosed with infertility conditions
              should consider consulting a fertility specialist.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              How do I know which fertility treatment is right for me?
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Each fertility journey is unique. Our specialists will conduct
              thorough evaluations, including medical history, diagnostic tests,
              and hormone assessments, to recommend the best treatment plan
              tailored to your needs.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              What is the success rate of IVF and other fertility treatments?
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Success rates depend on multiple factors, including age, overall
              health, and specific infertility conditions. At NCare IVF, our IVF
              success rate exceeds 75%, among the highest in the region.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Are fertility treatments painful or risky?
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Most fertility treatments, including IUI and IVF, are minimally
              invasive and cause little to no discomfort. Our team ensures your
              safety at every step with advanced techniques and personalized
              care.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              What should I expect during my first consultation?
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              During your first visit, our fertility experts will discuss your
              medical history, perform initial tests, and outline possible
              treatment options. This is the first step in understanding your
              fertility health and planning your journey ahead.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSix"
              aria-expanded="false"
              aria-controls="collapseSix"
            >
              What lifestyle changes can improve fertility?
            </button>
          </h2>
          <div
            id="collapseSix"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Eating healthy, staying active, and maintaining a healthy weight
              can improve fertility. Avoid smoking, alcohol, and too much
              caffeine. Managing stress with relaxation techniques like yoga and
              meditation also helps.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseSeven"
              aria-expanded="false"
              aria-controls="collapseSeven"
            >
              Does stress affect fertility?
            </button>
          </h2>
          <div
            id="collapseSeven"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Yes, high stress can disrupt hormones and affect fertility. It may
              lead to irregular periods in women and lower sperm quality in men.
              Relaxation, proper sleep, and emotional support can help manage
              stress.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseEight"
              aria-expanded="false"
              aria-controls="collapseEight"
            >
              Can I choose my baby’s gender in India?
            </button>
          </h2>
          <div
            id="collapseEight"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              No, gender selection is illegal in India under the PCPNDT Act.
              Fertility treatments focus on helping couples conceive a healthy
              baby, without gender preference.
            </div>
          </div>
        </div>
      </div>
      <button class="contact_us_info" (click)="contactus()">
        Contact Us for more information
      </button>
    </div>
  </section>
</div>
